<template>
  <div v-if="about">
    <!-- Investor Information -->
    <h3 class="mb-5">Employee Investment & Recruiting</h3>
    <div class="h4 mb-5">顯示於AboutUs頁面</div>
    <!-- Title -->
    <label class="form-item pt-5 d-flex">
      <h4 class="w-180px">Title</h4>
      <div class="flex-grow-1 my-n2">
        <v-textarea
          v-model="about.employee_title"
          outlined
          dense
        ></v-textarea>
      </div>
    </label>
    <!-- Description -->
    <label class="form-item pt-5 d-flex">
      <h4 class="w-180px">Description</h4>
      <div class="flex-grow-1 my-n2">
        <v-textarea
          v-model="about.employee_description"
          outlined
          dense
        ></v-textarea>
      </div>
    </label>
    <!-- Call to Action -->
    <label class="form-item pt-5 d-flex">
      <h4 class="w-180px">Call to Action</h4>
      <div class="flex-grow-1 my-n2">
        <v-text-field
          v-model="about.employee_call_to_action"
          outlined
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- img uploader -->
    <div class="form-item py-5 d-flex">
      <div class="w-180px">
        <h4 class="mb-10px">Visual</h4>
        <div class="h5 ink-02-medium--text">
          建議尺寸：650px * 900px <br />
          檔案大小限制：≤ 20 MB <br />
          支援格式：.png/.jpg/.gif
        </div>
      </div>
      <div class="flex-grow-1">
        <ImgUploader
          class="ml-auto"
          :imageUrl.sync="about.employee_visual"
          dir="about"></ImgUploader>
      </div>
    </div>

    <!-- Highlights -->
    <h3 class="my-5">Recruiting Highlight</h3>
    <div class="h4 mb-5">可擴充</div>
    <div class="form-item" v-for="(item, i) in about.employee_highlight" :key="i">
      <!-- highlight -->
      <label class="d-flex align-center mt-5px">
        <h5 class="w-174px pr-5">Highlight {{ i + 1 }}</h5>
        <div class="flex-grow-1 pt-5">
          <v-text-field
            v-model="item.title"
            outlined
            dense
          ></v-text-field>
        </div>
        <div class="ml-5 my-n2">
          <button class="btn square mr-10px" @click="deleteItem(i)">
            <v-icon>delete</v-icon>
          </button>
        </div>
      </label>
    </div>
    <!-- add -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon color="brand-01-emphasis" class="mr-2">add_circle</v-icon>
        <span>添加Rescruiting Highlight</span>
      </button>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgUploader,
  },
  methods: {
    addItem() {
      const template = {
        title: '',
      };
      this.about.employee_highlight.push(template);
    },
    deleteItem(index) {
      this.about.employee_highlight.splice(index, 1);
    },
  },
};
</script>

<style></style>
